import type { Field } from './types';

const TIME = /^(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d)?$/;
export function temporalError(field: Field, answer: string): string | null {
  if (field.type === 'time') {
    return (field.timeMode === 'duration' ? /^\d{1,6}:[0-5]\d:[0-5]\d$/.test(answer) : TIME.test(answer)) ? null : field.timeMode === 'duration' ? 'Enter a duration in hours, minutes, and seconds.' : 'Enter a valid time.';
  }
  const [date, time, extra] = answer.split('T');
  const includeYear = field.includeYear !== false;
  if (!(includeYear ? /^\d{4}-\d{2}-\d{2}$/ : /^\d{2}-\d{2}$/).test(date)) return includeYear ? 'Enter a date like 6/12/2026.' : 'Enter a valid month and day.';
  const full = includeYear ? date : `2000-${date}`;
  const parsed = new Date(`${full}T00:00:00Z`);
  if (Number.isNaN(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== full) return 'Enter a valid calendar date.';
  if (extra !== undefined || (field.includeTime ? !time || !TIME.test(time) : time !== undefined)) return field.includeTime ? 'Enter a valid date and time.' : 'Enter a date without a time.';
  return null;
}
